// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--xUTLQ","image":"_02712f2b3b--image--DHZyd","title":"_02712f2b3b--title--PNHRR","content":"_02712f2b3b--content--aLkNG"};